import BaseFactor from "@/types/Config/Factor";

/** Type Facteur d'influence spécifique à la fonction Evolution */
export default class Factor extends BaseFactor {
    constructor(id: string) {
        super(id);
    }

    Filters: string[] = [];
}